import React from 'react';
import MuiContainer from '@material-ui/core/Container';
import styled from 'styled-components';
import SearchPageBanner from 'src/components/Common/pageBanner';
import { NextSeo } from 'next-seo';
import { Button } from '@material-ui/core';
import ListingsApis from '../api/listings';
import BlogCard from '../components/BlogCard';
import useBlog from '../hooks/api/useBlog';

const Container = styled(MuiContainer)`
  display: flex !important;
  flex-direction: column;
  align-items: center;
`;
const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 30px 0;
  width: 100%;
`;
const StyledCard = styled(BlogCard)`
  width: 350px;
`;
const ViewMore = styled(Button)`
  margin: 20px 0 !important;
  padding: 10px 20px !important;
  align-self: center;
`;

interface Blogs {
  canonicalUrl: string;
  SSRBlogs: any;
}
const Blogs = ({ canonicalUrl, SSRBlogs }: Blogs) => {
  const { blogs, setPerPage, isLoading } = useBlog(SSRBlogs);
  return (
    <>
      <NextSeo
        canonical={canonicalUrl}
        title="Blogs | Rentable blogs"
        description="List of all blogs"
        openGraph={{
          url: canonicalUrl,
          title: 'Blogs | Rentable blogs',
          description: 'List of all blogs',
          images: [
            {
              url: 'https://rentable.pk/assets/logos/green-text-logo.png',
              alt: 'Rentable Pakistan',
            },
          ],
        }}
      />
      <SearchPageBanner />
      <Container maxWidth="lg">
        <h1 style={{ marginTop: '40px' }}>Blog collection</h1>
        <Content>
          {blogs &&
            blogs.map((blog: any, key: number) => {
              return <StyledCard key={key} blogData={blog} />;
            })}
        </Content>
        <ViewMore
          color="primary"
          disabled={isLoading}
          onClick={() => setPerPage((m: number) => m + 9)}
          variant="contained"
        >
          {(isLoading && '...Loading') || 'View more'}
        </ViewMore>
      </Container>
    </>
  );
};

export const getStaticProps = async () => {
  const canUrl = 'https://rentable.pk/blogs';
  const result = await ListingsApis.fetchBlogListings(9);
  const blogs = result.data.data;
  return {
    props: {
      canonicalUrl: canUrl,
      SSRBlogs: blogs,
    },
  };
};

export default Blogs;
